import ReferencePathService from "~/services/referencePathServices/referencePathService";
import {IReferencePathNodeForm, IReferencePathNodeSpecific} from "~/interfaces/referencePathInterfaces"
import Form from "../../../formability/form_builder/models/form";
import {ReferenceNodeType} from '~/enums/referenceNodeType'
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import {ModelType} from '~/enums/modelType'

export default class FormPathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.Form

  constructor(private formNode: IReferencePathNodeForm) {
    super();
  }

  get label(): string {
    return this.formNode.reference()?.titleOrDefault;
  }

  get nodes(): IReferencePathNodeForm[] {
    return [this.formNode];
  }

  reference(): Form {
    return Form.repo.findById(this.formNode.reference_id);
  }

  get referenceGenericModelType(): GenericType {
    return this.reference()?.genericType
  }

  get referenceModelType(): ModelType {
    return this.reference()?.modelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    let decision: boolean
    if (!this.referenceExists) return false // own reference (form) has to exist
    if (!node) return true // form node can be the last node in the list
    const form = this.reference()
    switch (node.reference_type) {
      case ReferenceNodeType.WorkflowStep:
        // can link to workflow step if step is attached to form
        const workflowStep = node.reference()
        decision = Boolean(workflowStep) && Boolean(form.workflowStepsArray.find(ws => ws.id === workflowStep.id))
        break;
      case ReferenceNodeType.OriginalSubmitter: // intentional fall-through
      case ReferenceNodeType.RecordHolder:
      case ReferenceNodeType.WorkflowStepStart:
      case ReferenceNodeType.WorkflowStepEnd:
      case ReferenceNodeType.FormSubmissionDate:
      case ReferenceNodeType.FormSubmissionID:
        decision = true
        break;
      // case ReferenceNodeType.FormElement: must go through workflow step node first - workflow step node tests link to form element
      default:
        decision = false
        break
    }
    this.debugCanLinkTo('FormPathService', this.formNode, node, decision)
    return decision
  }

  get referenceIsCollection(): boolean {
    return false
  }

  get referenceIsInitializable(): boolean {
    return true;
  }

}